import React from "react";

const Spinner = ({ size = 64 }) => (
  <div
    style={{
      position: "absolute",
      inset: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "rgba(255, 255, 255, 0.8)",
      zIndex: 10,
      padding: "1rem",
    }}
  >
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      role="img"
      aria-label="Loading"
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke="#0B3C5D"
        strokeWidth="5"
        opacity="0.2"
      />
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke="#F4D35E"
        strokeWidth="5"
        strokeLinecap="round"
        strokeDasharray="31.4 94.2"
        transform="rotate(-90 25 25)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="1s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  </div>
);

export default Spinner;
